/* eslint-disable react/no-unescaped-entities */

import { useRouter } from "next/router"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { isMobile } from "../utils/browser"
import Header from "../components/Header"
import Footer from "../components/local/Footer"
import AboutUsEN from "../components/local/AboutUs/AboutUsEN"
import AboutUsDE from "../components/local/AboutUs/AboutUsDE"
import AboutUsES from "../components/local/AboutUs/AboutUsES"
import AboutUsFR from "../components/local/AboutUs/AboutUsFR"
import AboutUsIT from "../components/local/AboutUs/AboutUsIT"
import AboutUsPT from "../components/local/AboutUs/AboutUsPT"
import Styles from "./about-us.module.scss"
import TalkToSolace from "../components/TalkToSolace"
import { getBlogPost, getBlogPosts } from "../utils/blog"

export async function getStaticProps({ locale, locales }) {
  const { posts, postsUnordered } = await getBlogPosts({
    locale,
    params: "?tags=40",
  })

  const language = locale.split("-")[0] || "en"

  const postIds = {
    en: 206,
    de: 210,
    es: 208,
    fr: 212,
    it: 214,
    pt: 216,
  }

  const postId = postIds[language] || 206

  const { content: { rendered: post = "" } = {} } = await getBlogPost({
    postId,
  })

  return {
    props: {
      ...(await serverSideTranslations(locale.substring(0, 2), [
        "tests",
        "common",
      ])),
      post,
      posts,
      locales,
      postsUnordered,
    },
  }
}

function PrivacyPolicyByLang() {
  const { locale } = useRouter()

  const language = locale.substring(0, 2)

  if (language === "pt") {
    return <AboutUsPT />
  }

  if (language === "es") {
    return <AboutUsES />
  }

  if (language === "de") {
    return <AboutUsDE />
  }

  if (language === "fr") {
    return <AboutUsFR />
  }

  if (language === "it") {
    return <AboutUsIT />
  }

  return <AboutUsEN />
}

function PrivacyPolicy({ post }) {
  return (
    <div className={Styles.Wrapper}>
      <Header logoUrl="/assets/logo-black.png" fixedHeader={isMobile()} />

      <div className={Styles.Content} id="page-wrap">
        <div className="max-w-2xl mx-auto px-4 py-8">
          <div dangerouslySetInnerHTML={{ __html: post }} />

          <div>
            <TalkToSolace />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default PrivacyPolicy
